module.exports = __webpack_public_path__ + "static/img/siji.8e11ef0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page_productcenter/siji.png
// module id = Ad06
// module chunks = 1